<div class="tutorial-sheet-card">
  <div class="tutorial-sheet-header">
    <span class="tutorial-badge">{{ tutorialService.activeStepProgressLabel }}</span>
    <button type="button" class="tutorial-close-btn" (click)="cancelTutorial()" [attr.aria-label]="'Exit tutorial' | translate">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
  <p class="tutorial-sheet-title">{{ tutorialService.activeStepTitle }}</p>
  <p class="tutorial-sheet-text">{{ tutorialService.activeStepBody }}</p>
  <div *ngIf="tutorialService.activeStepWarning" class="tutorial-warning-callout" role="alert" aria-live="polite">
    <span class="tutorial-warning-label">{{ 'Warning' | translate }}</span>
    <p class="tutorial-warning-text">{{ tutorialService.activeStepWarning }}</p>
  </div>

  <div *ngIf="tutorialService.shouldShowDashboardControllerGadgetPicker" class="tutorial-inline-picker">
    <label class="tutorial-inline-picker-label" for="dashboard-tutorial-gadget-select">{{ 'Choose gadget' | translate }}</label>
    <select id="dashboard-tutorial-gadget-select" class="tutorial-inline-picker-select"
      [value]="tutorialService.dashboardControllerSelectedGadgetId"
      (change)="onDashboardControllerGadgetChanged($any($event.target).value)">
      <option *ngFor="let gadget of tutorialService.dashboardControllerStepGadgetOptions" [value]="gadget.id">
        {{ gadget.name }}
      </option>
    </select>
  </div>

  <div *ngIf="tutorialService.hasActiveStepAction" class="tutorial-sheet-actions">
    <button type="button" class="tutorial-complete-button tutorial-continue-button"
      [disabled]="!tutorialService.isActiveStepActionEnabled"
      [class.tutorial-continue-button-disabled]="!tutorialService.isActiveStepActionEnabled"
      (click)="runTutorialStepAction()">
      {{ tutorialService.activeStepActionLabel }}
    </button>
  </div>
</div>
